import React from "react";
import { Link, Outlet } from "react-router-dom";
import "./AdminLayout.css";

export default function AdminLayout() {
  return (
    <div className="admin-root">
      <header className="admin-header">
        <span className="admin-brand">Nature4D — Admin</span>
        <Link className="admin-back" to="/">
          Back to site
        </Link>
      </header>
      <div className="admin-main">
        <Outlet />
      </div>
    </div>
  );
}
